import { updateKeyInStore } from 'App';
import { IncomeFromTheUsStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof IncomeFromTheUsStateValues>[] = [
  {
    name: 'pleaseUploadFormW2',
    label: 'Please upload Form W-2',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.wages.incomeFromTheUs.values.didYouReceiveWagesDuringTheYearFromAUsEmployer',
  },
  {
    name: 'pleaseUploadForm1099Misc',
    label: 'Please upload Form 1099-MISC or 1099-NEC',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.wages.incomeFromTheUs.values.didYouPerformWorkAsAConsultantOrIndependantContractorForAUsFirm',
  },
  {
    name: 'pleaseUploadACopyOfForm1099MiscOrFormK1',
    label: 'Please upload a copy of form 1099-MISC or form K-1',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.wages.incomeFromTheUs.values.didYouReceieveRoyaltiesUnemploymentPaymentsOrOtherMiscellaneousIncomeFromAUsSource',
  },
];
